import { render, staticRenderFns } from "./CecUnmPortfolioDetail.vue?vue&type=template&id=22c756fa&scoped=true"
import script from "./CecUnmPortfolioDetail.vue?vue&type=script&lang=js"
export * from "./CecUnmPortfolioDetail.vue?vue&type=script&lang=js"
import style0 from "./CecUnmPortfolioDetail.vue?vue&type=style&index=0&id=22c756fa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c756fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22c756fa')) {
      api.createRecord('22c756fa', component.options)
    } else {
      api.reload('22c756fa', component.options)
    }
    module.hot.accept("./CecUnmPortfolioDetail.vue?vue&type=template&id=22c756fa&scoped=true", function () {
      api.rerender('22c756fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/cecunmportfolio/CecUnmPortfolioDetail.vue"
export default component.exports